import React from 'react';

import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';

import { getCurrentStep } from '@src/containers/LoanDecision/LoanDecision.selectors';

import messages from './ApplicationInfo.messages';
import styles from './ApplicationInfo.module.css';
import { PencilSVG } from './PencilSVG';
import LoanRequestDetails from '../../containers/LoanRequestDetails';
import * as LoanRequestOptions from '../../containers/LoanRequestDetails/constants';
import {
    CLOSE_MODAL,
    OPEN_MODAL
} from '../../containers/Modals/Modals.actions';
import { localeCurrency } from '../../helpers/constants';
import {
    getApplicantEmail,
    getCountryCode,
    missingRequiredApplicationDetails as missingRequiredApplicationDetailsSelector
} from '../../lendingAPI/lendingAPISelector';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';
import { getRequestedAmount } from '../../utils/selectors';
import EditModal from '../EditModal';

const mapStateToProps = (state) => {
    return {
        emailAddress: getApplicantEmail(state),
        openModalId: state.modals.openModalId,
        requestedAmount: getRequestedAmount(state),
        missingRequiredApplicationDetails:
            missingRequiredApplicationDetailsSelector(state),
        currency: localeCurrency[getCountryCode(state)],
        currentStep: getCurrentStep(state)
    };
};

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL }),
    editApplication: () =>
        dispatch({ type: OPEN_MODAL, modalId: 'sidebarLoanRequestSummary' })
});

const ApplicationInfo = ({
    emailAddress,
    editApplication,
    closeModal,
    openModalId,
    isMobile,
    requestedAmount,
    missingRequiredApplicationDetails,
    currency,
    currentStep
}) => {
    const messageToDisplay = isMobile
        ? messages.applicationInfoMobile
        : messages.applicationInfo;

    return (
        <div>
            {requestedAmount && (
                <span
                    data-testid="application-info"
                    className={styles.applicationInfo}>
                    <FormattedMessage
                        {...messageToDisplay}
                        values={{
                            emailAddress: <b>{emailAddress}</b>,
                            requestedAmount: (
                                <span
                                    className={`${styles.requestedAmount} ${
                                        currentStep === 'businessAccounts' &&
                                        styles.requestAmountDisabled
                                    }`}
                                    data-testid="open-edit-application"
                                    onClick={() => {
                                        if (
                                            currentStep !== 'businessAccounts'
                                        ) {
                                            editApplication();
                                            GoogleTagManager.trackClick({
                                                identifier: 'Edit loan details',
                                                deviceType: isMobile
                                                    ? 'Mobile'
                                                    : 'Desktop'
                                            });
                                            tracking.ampli.editAmountOpened({
                                                amount: requestedAmount,
                                                ...getAmplitudeDefaultEventProperties()
                                            });
                                        }
                                    }}>
                                    <ApplicationAmount
                                        amount={requestedAmount}
                                        currency={currency}
                                    />
                                    {currentStep !== 'businessAccounts' && (
                                        <PencilSVG />
                                    )}
                                </span>
                            )
                        }}
                    />
                </span>
            )}

            <EditModal
                isOpen={openModalId === 'sidebarLoanRequestSummary'}
                mandatory={missingRequiredApplicationDetails}>
                <LoanRequestDetails
                    closeModal={closeModal}
                    options={LoanRequestOptions}
                    formKey="loanRequestDetails"
                />
            </EditModal>
        </div>
    );
};

const ApplicationAmount = ({ amount, currency }) => (
    <FormattedNumber
        value={amount}
        style="currency"
        minimumFractionDigits={0}
        maximumFractionDigits={0}
        currency={currency}
    />
);

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationInfo);
